import React from 'react'

const TONUSD = () => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' fill='white' />
      <rect x='0.5' y='0.5' width='47' height='47' rx='23.5' stroke='#D1D3E5' />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M17.3143 15.8571H30.7714C31.2857 15.8571 31.7143 15.9429 32.2286 16.2C32.8286 16.4571 33.1714 16.8857 33.3429 17.2286C33.3429 17.2286 33.3428 17.3143 33.4286 17.3143C33.6857 17.7429 33.8571 18.2571 33.8571 18.8571C33.8571 19.3714 33.7714 19.8857 33.4286 20.4L24.9429 34.9714C24.7714 35.3143 24.4286 35.4857 24 35.4857C23.6571 35.4857 23.3143 35.3143 23.0571 34.9714L14.7429 20.4C14.5714 20.0571 14.2286 19.6286 14.2286 18.9429C14.1429 18.3429 14.3143 17.8286 14.5714 17.3143C14.8286 16.8 15.2571 16.3714 15.8571 16.2C16.3714 15.8571 16.9714 15.8571 17.3143 15.8571ZM22.9714 17.9143H17.3143C16.9714 17.9143 16.8 17.9143 16.7143 18C16.5429 18.0857 16.4571 18.1714 16.3714 18.3429C16.2857 18.4286 16.2857 18.6 16.2857 18.7714C16.2857 18.8571 16.3714 18.9429 16.5428 19.2857L22.9714 30.4286V17.9143ZM25.0286 17.9143V30.5143L31.5429 19.2857C31.6286 19.1143 31.6286 18.9429 31.6286 18.7714C31.6286 18.6 31.6286 18.4286 31.5429 18.3429C31.4571 18.2571 31.4571 18.1714 31.3714 18.1714L31.2857 18.0857C31.1143 18 30.9429 18 30.6857 18H25.0286V17.9143Z'
        fill='#0088CC'
      />
    </svg>
  )
}

export default TONUSD
